import React from 'react';
import { classNames, layoutClassNames, LayoutClassNameProps } from './classNames';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement>, LayoutClassNameProps {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}, ref) => (
  <textarea
    ref={ref}
    className={classNames(
      'form-control',
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  />
));

Textarea.displayName = 'Textarea';

export default Textarea;
